import React from 'react';
import {DateRangePicker, Button, Tooltip, Whisper} from 'rsuite';
import {addDays, subDays, subHours} from 'date-fns';
const {combine, afterToday} = DateRangePicker;

const tooltip = (
    <Tooltip>
        Use this to toggle the calendar selection from day to week selection.
    </Tooltip>
);

export default function RDateRangePicker(props){
    const [dateSelection, setDateSelection] = React.useState(null);
    const [weekToggle, setWeekToggle] = React.useState('Day');

    function handleOnChange(value, event){
        if (value){
            props.onChange({startDate: new Date(value[0]), endDate: new Date(value[1])});
        } else {
            props.onChange({startDate: subHours(new Date(), 24), endDate: new Date()});
        }
    }
    function handleSelectionChange(){
        dateSelection ? (setDateSelection(null) || setWeekToggle('Day')) : (setDateSelection('week') || setWeekToggle('Week'));
    }
    return (
        <div id='RDateRangePicker'>
            <Whisper placement="bottom" controlId="control-id-hover" trigger="hover" speaker={tooltip}>
                <Button onClick={handleSelectionChange}>{weekToggle} Selection</Button>
            </Whisper>
            {/*<span>*/}
            {/*    <Button onClick={handleSelectionChange}>Week Selection</Button>*/}
            {/*</span>*/}
            <DateRangePicker
                placement='bottomEnd'
                preventOverflow
                placeholder='Last 24 Hours'
                ranges={[
                    {
                        label: '4 Hours',
                        value: [subHours(new Date(), 4), new Date()]
                    },
                    {
                        label: '12 Hours',
                        value: [subHours(new Date(), 12), new Date()]
                    },
                    {
                        label: '24 Hours',
                        value: [subHours(new Date(), 24), new Date()]
                    },
                    {
                        label: 'Last 7 days',
                        value: [subDays(new Date(), 6), new Date()]
                    },
                    {
                        label: 'Yesterday',
                        value: [subHours(new Date(), 48), subHours(new Date(), 24)]
                    },
                    // {
                    //     label: 'Today',
                    //     value: [today, new Date()]
                    // }
                ]}
                disabledDate={afterToday()}
                hoverRange={dateSelection}
                format="MM/dd/yyyy HH:mm"
                onChange={handleOnChange}
                // renderValue={(value, format) => {
                //     console.log({value});
                //     console.log({format});
                //     console.log({self});
                //     return 'Hello';
                // }}
            />
        </div>
    );
}
